import { Col, Divider, Row } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const DateType = ({value}) => {

const date = dayjs(value);

const jour = date.format('DD'); 

const moisAnnee = date.format('MMM YYYY'); 




    return (
        <div style={{width:"100%"}}>

            <Row align="middle" style={{ fontSize: '16px' }}>
                <Col style={{marginRight:"1%"}}>
                    <span style={{ fontWeight: 650, }}> {moisAnnee}</span>
                </Col>
                <Col>
                     <Divider className='styleDivider' size='large' type="vertical" style={{ fontSize:"30px", borderLeft: '1.3px solid rgba(0, 0, 0, 0.85)',}}  />
                </Col>
                <Col style={{ marginLeft:"1%",  backgroundColor: '#F0EBF8',
                    borderRadius: '2rem', padding:"0.6% 1.4%"}}>
                    <div style={{
                   
                    }}>
                     {jour}
                    </div>
                </Col>
            </Row>
            
        </div>
    );
};

export default DateType;